import { render, staticRenderFns } from "./card.vue?vue&type=template&id=ca850102"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=ca850102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,ProductPrices: require('/app/components/product/prices.vue').default,ProductWishlist: require('/app/components/product/wishlist.vue').default,Loader: require('/app/components/loader.vue').default})
